import { Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import BottomDrawer from '../../elements/drawers/BottomDrawer';
import Image from 'next/image';
import { IoExitOutline } from 'react-icons/io5';
import ConfirmLeaveGroup from '../../elements/storage/ConfirmLeaveGroup';
import { AiFillCaretDown } from 'react-icons/ai';

interface ILeaveGroupButton {
  handleLeaveGroup: () => void;
}

const LeaveGroupBtn: React.FunctionComponent<ILeaveGroupButton> = ({
  handleLeaveGroup,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openLeaveGroupModal, setOpenLeaveGroupModal] =
    useState<boolean>(false);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <button
        id="leave-group-btn"
        aria-controls={open ? 'leave-group-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        className="w-full sm:w-fit py-2 px-[22.5px] rounded-lg transition-all hover:bg-gray-100 border border-[#E0E0E0] bg-transparent flex items-center justify-center gap-2 text-sm leading-[16px] tracking-[-0.1px] font-semibold"
      >
        <Image
          src="/icons/check-black.svg"
          alt="check icon"
          width={20}
          height={20}
        />
        <p>Đã tham gia</p>
        <AiFillCaretDown size={15} />
      </button>
      <div>
        {/* desktop */}
        <Menu
          className="hidden sm:block"
          id="leave-group-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'leave-group-btn',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          sx={{
            '.MuiPaper-root': {
              marginTop: '8px !important',
              borderRadius: '8px !important',
            },
          }}
        >
          <MenuItem
            className="flex gap-2 items-center w-[285px] text-red-500"
            onClick={() => {
              setOpenLeaveGroupModal(true);
              handleClose();
            }}
          >
            <IoExitOutline color="red" /> Rời nhóm
          </MenuItem>
        </Menu>
        {/* mobile */}
        <BottomDrawer isOpen={open} handleClose={handleClose}>
          <MenuItem
            className="flex gap-2 items-center py-5 text-red-500"
            onClick={() => {
              setOpenLeaveGroupModal(true);
              handleClose();
            }}
          >
            <>
              <IoExitOutline color="red" /> Rời nhóm
            </>
          </MenuItem>
        </BottomDrawer>
      </div>
      <ConfirmLeaveGroup
        isOpen={openLeaveGroupModal}
        handleClose={() => setOpenLeaveGroupModal(false)}
        callback={handleLeaveGroup}
      />
    </>
  );
};

export default LeaveGroupBtn;
